import { LoginResult, RawLoginResult } from '../../Models/LoginResult';
import { Translations } from '../../Translations/Translations';
import { AppConfigProvider } from '../AppConfigProvider';
import { ClientInfoProvider } from '../Storage/ClientInfoProvider';
import { IAuth } from './IAuth';


export class Auth implements IAuth
{
    private Log(...msg: any[])
    {
        console.log('[Auth]', ...msg);
    }

    constructor(
        private _config: AppConfigProvider,
        private _lang: Translations,
        private _clientInfo: ClientInfoProvider
    ) { }

    public async TryLogin(password: string): Promise<LoginResult>
    {
        try
        {
            const serverInfo = this._config.ServerInfo;

            this.Log(`Trying to login to ${serverInfo.Name} (${serverInfo.Addr}) using '${password}' password...`);

            const payload = {
                Password: password,
                WatcherId: this._clientInfo.ClientId
            };
            const response = await fetch(`${serverInfo.Addr}/watcher/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            switch (response.status)
            {
                case 200:
                    const loginResult = await response.json() as RawLoginResult;
                    const deviceId = loginResult.DeviceId || "(unknown device id)";
                    this.Log(`Login successful. This password is attached to ${deviceId}`);
                    return LoginResult.Success(deviceId);
                default:
                case 401:
                    this.Log('Unauthorized');
                    return LoginResult.Unauthorized(this._lang.Unauthorized);
            }
        }
        catch (ex: any)
        {
            this.Log('Faulty login result:', ex.message);
            return LoginResult.NetworkError(this._lang.NetworkError);
        }
    }
}
